import React from 'react';
import ReactDOM from 'react-dom/client';
import WakenMusicForm from './WakenMusicForm';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <WakenMusicForm />
  </React.StrictMode>
);
